import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import ALoader from 'views/pages/manage/common/a-loader';
import { isValidReqObj, newRow, } from './constant';
import { GridRowModes } from '@mui/x-data-grid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { ActionsCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { Box, Tooltip } from '@mui/material';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { ReactComponent as EyeIcon } from 'assets/img/svg/eyeIcon.svg';
import AInput from '../../common/formFeilds/customInput/AInput';
import Logs from './Logs';
import { getAuditDetail } from './apis';
import { processRowList } from '../../businessArea/component/FirstForm/constant';
import { numberDecimalLimitRegex } from '../../unAssigned/collectPayment/selectPaymentMode/components/constant';
import { regex } from '../../common/constant';

const ListComponent = forwardRef(({
    rows,
    loader,
    dropdowns,
    createUpdateHandler,
    deleteHandler,
    currentPage,
    setLoader,
    totalRecords,
    currentPageSize,
    searchArpuList
}, ref) => {
    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});
    const [isOpenDialog, setIsOpenDialog] = useState(false)
    const [open, setOpen] = useState(false)

    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);

    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };
    const handleDeleteClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            deleteHandler(params?.row)
        }
    }

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: generateRandomId(),
            };
            // let randomId = JSON.stringify(emptyRow);
            startEditing(emptyRow?.id, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const columns = [
        new AGridColDef("businessArea", "Business Area", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.businessArea}
                        handleChange={value => {
                            rowFormHandler(value, 'businessArea');
                        }}
                        items={dropdowns?.businessArea}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef("courseCategory", "Course Category", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value?.label}>
                    <div className={`ellipsis-text-container cursor`}>
                        {params.value?.label}
                    </div>
                </Tooltip> : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.courseCategory}
                        handleChange={value => {
                            rowFormHandler(value, 'courseCategory');
                        }}
                        items={dropdowns?.courseCategory}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef("term", " Term", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.term}
                        handleChange={value => {
                            rowFormHandler(value, 'term');
                        }}
                        items={dropdowns?.term}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef("academicGroup", "Academic Group", false)
            .setMinWidth(120)
            .editable(true)
            .setFlex(1.2)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.academicGroup}
                        handleChange={value => {
                            rowFormHandler(value, 'academicGroup');
                        }}
                        items={dropdowns?.academicGroup}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>)),
        new AGridColDef("academicCareer", "Carrier", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.academicCareer}
                        handleChange={value => {
                            rowFormHandler(value, 'academicCareer');
                        }}
                        items={dropdowns?.academicCareer}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>)),
        new AGridColDef("amount", "Amount (₹)", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AInput
                        placeholder='Enter'
                        value={rowForm?.amount}
                        handler={(value) => {
                            rowFormHandler(value, "amount")
                        }}
                        regex={numberDecimalLimitRegex(10, 2)}
                    />
                </div>
            )),
             new AGridColDef("concessionPercentage", "Concession (%)", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AInput
                        placeholder='Enter'
                        value={rowForm?.concessionPercentage}
                        handler={(value) => {
                            if(value==='0'){
                                return;
                            }
                            rowFormHandler(value, "concessionPercentage")
                        }}
                        regex={regex.percentage}
                    />
                </div>
            )),
        new AGridColDef("status", "Actions", false)
            .setMinWidth(80)
            // .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                <div className='d-flex align-items-center' style={{ gap: '15px' }}>
                    <ActionsCellComponent
                        mode={params.api.getRowMode(params?.id)}
                        handleEditClick={handleEditClick}
                        handleSaveClick={handleSaveClick}
                        handleCancelClick={handleCancelClick}
                        handleDeleteClick={handleDeleteClick}
                        icon={true}
                        cancelIcon={<CancelIcon
                            className="mx-2 cursor"
                            onClick={() => handleCancelClick(params)}
                        />}
                        deleteIcon={true}
                        params={params}
                        isSaveDisabled = {!isValidReqObj(rowForm)}
                        // editPermission={userPermissions?.includes("U")}
                        // deletePermission={userPermissions?.includes("D")}
                        customEditIcon
                    />
                    <EyeIcon className='cursor' onClick={() => { handleOpen(params?.row?.id) }} />
                </div>
            )),

    ]

    const onChangeHandler = (page, pageSize) => {
        searchArpuList({page:page, pageSize})
    }

    const handleClose = () => {
        setIsOpenDialog(false)
    }
    const handleOpen = async (id) => {
        try{
        setLoader(true)
        const res = await getAuditDetail(id)
        setIsOpenDialog(processRowList(res,dropdowns));
        }
        catch(err){
        console.error(err)
        }
        finally{
            setLoader(false)
        }
        
    }
    console.log(totalRecords,currentPage,currentPageSize)
    return (<>
    {loader && <ALoader position='fixed'/>}
        <ADataGrid
            paginationModel={{ page: currentPage, pageSize: currentPageSize }}
            removeWrapperContainer
            rowModesModel={rowModesModel}
            rows={rowData || []}
            columns={columns}
            rowId={(row) => row.id}
            rowHeight={50}
            // loading={loader}
            rowCount={totalRecords}
            nextButtonHandler={onChangeHandler}
            currentPage={currentPage}
            // components={{
            //     ...gridComponents,
            //     NoRowsOverlay: () => (
            //         <NoRowOverlay message={loader ? "Loading..." : null} />
            //     ),
            // }}
            sx={gridStyles}
            autoHeight
        // pinLastColumn
        />
        <Logs
            handleClose={handleClose}
            isOpenDialog={isOpenDialog}
            loader={loader}
        />
        {/* <ConfirmDeletionDialog
         handleClose
        /> */}

    </>
    );
})

export default ListComponent